import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';

import { fetchForm, fetchOrder } from '~services/api.helpers';
import { populateFormFromOrder } from '~utils/form.utils';

import { primaryColor } from '~theme';
import { Buttons, ErrorMessage } from '../../styled';
import { Button } from '~ui-kit';
import Notice from './Notice';
import FormContext from './FormContext';

const FormWrapper = props => {
  const {
    formId,
    title,
    Component,
    formik,
    edit,
    returnOrder,
    disabled,
    hideSubmitButton,
    hideButtons,
  } = props;
  const { orderId } = useParams();
  const [form, setForm] = useState(null);

  useEffect(() => {
    const update = async () => {
      const form = await fetchForm(formId);
      setForm(form);

      // Fill form fields if we're editing an existing order
      if (edit && form.formType !== 'CUSTOM_FORM_INTERNALPATIENTTRANSPORT') {
        const order = await fetchOrder(orderId);
        if (order?.fields) {
          populateFormFromOrder(formik.setValues, order.fields);
        }
      }
    };

    try {
      if (formId) {
        update();
      } else {
        console.debug(
          `%cformId was not found for form ${title}. It's probably missing from the navigation. Make sure to add it in the admin interface!`,
          'color:white;background-color:#233c78'
        );
      }
    } catch (e) {
      console.error('Error in FormWrapper when fetching form', e);
    }
  }, [formId]);

  const isSubmitting = formik?.isSubmitting;

  const navigate = useNavigate();

  return (
    <Wrapper>
      {edit && <Header>Muokataan tilausta {orderId}</Header>}
      {returnOrder && (
        <Header>Tilataan paluukuljetusta tilaukselle {orderId}</Header>
      )}
      <Header>{form ? form.heading : title}</Header>
      {form && form.alertLevel && form.alertString && <Notice form={form} />}

      <Content>
        <Form>
          <FormContext.Provider value={form}>
            <Component {...props} form={form} />
          </FormContext.Provider>
        </Form>
      </Content>
      <Controls>
        <ErrorMessage isVisible={!formik.isValid && formik.submitCount > 0}>
          Huom. Tähdellä merkityt kentät ovat pakollisia.
        </ErrorMessage>

        {!hideButtons && (
          <Buttons>
            <Button cancel onClick={() => navigate('/tilauslista')}>
              Peruuta
            </Button>
            {!hideSubmitButton && (
              <Button
                secondary
                disabled={disabled || isSubmitting}
                $loading={isSubmitting ? true : undefined}
                type="submit"
                onClick={value => {
                  if (!isSubmitting && !disabled) formik.handleSubmit(value);
                }}
              >
                Lähetä
              </Button>
            )}
          </Buttons>
        )}
      </Controls>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 4px;
`;

const Content = styled.div``;

const Header = styled.h4`
  color: ${primaryColor};
  font-weight: 400;
  font-size: 32px;
  margin-bottom: 40px;
  padding-left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 32px;

  @media (max-width: 768px) {
    word-wrap: break-word;
    font-size: 24px;
    // hyphens: auto;
    overflow-x: hidden;
    overflow-y: hidden;
  }
`;

const Controls = styled.div``;

export default FormWrapper;
